import axios from "axios";
import { toast } from "react-toastify";
import {
  ATTENDANCE_FETCH_REQUEST,
  ATTENDANCE_FETCH_SUCCESS,
  ATTENDANCE_FETCH_FAILURE,
} from "../../types/HrTypes";

export const loadAttendanceByDate = (date) => async (dispatch) => {
  dispatch({ type: ATTENDANCE_FETCH_REQUEST });
  try {
    const { data } = await axios.get("hr/attendance", { params: { date } });
    dispatch({ type: ATTENDANCE_FETCH_SUCCESS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: ATTENDANCE_FETCH_FAILURE, payload: error.message });
  }
};

export const loadWorkerAttendance = (workerId, from, to) => async () => {
  try {
    const { data } = await axios.get(`hr/attendance/worker/${workerId}`, { params: { from, to } });
    return data;
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return [];
  }
};

export const markAttendance = (values) => async () => {
  try {
    const { data } = await axios.post("hr/attendance", values);
    toast.success("Attendance marked");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const bulkMarkAttendance = (values) => async () => {
  try {
    const { data } = await axios.post("hr/attendance/bulk", values);
    toast.success(`${data.count} attendance records saved`);
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const updateAttendance = (id, values) => async () => {
  try {
    const { data } = await axios.put(`hr/attendance/${id}`, values);
    toast.success("Attendance updated");
    return { message: "success", data };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};

export const deleteAttendance = (id) => async () => {
  try {
    await axios.delete(`hr/attendance/${id}`);
    toast.warning("Attendance deleted");
    return { message: "success" };
  } catch (error) {
    toast.error(error.response?.data?.message || error.message);
    return { message: "error" };
  }
};
